import { render } from "./CardTitleComp.vue?vue&type=template&id=a5d8aeb4&scoped=true"
import script from "./CardTitleComp.vue?vue&type=script&lang=js"
export * from "./CardTitleComp.vue?vue&type=script&lang=js"

import "./CardTitleComp.vue?vue&type=style&index=0&id=a5d8aeb4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5d8aeb4"]])

export default __exports__